import * as React from "react";
import { IconModel } from "../../models";
import { HamburgerNavigationIcon } from "../HamburgerNavigationIcon";

export class HamburgerNavigationItem extends React.Component<{
    href: string,
    title: string,
    icon: IconModel,
    handler: any,
    count?: number,
    displayIcon?: Boolean
}, {}> {
    constructor(props) {
        super(props)
    }

    /* istanbul ignore next */
    render() {
        const iconClass = "rj-hamburger-nav-item-icon";
        const displayIcon = this.props.displayIcon !== undefined ? this.props.displayIcon : true;
        const isCmsLinkIconEmpty = this.props.icon.presetImage === "" && this.props.icon.cmsImage === undefined;

        const navIcon = (displayIcon && !isCmsLinkIconEmpty)
            ? (<HamburgerNavigationIcon iconId={this.props.icon.cmsImage} cmsClass={this.props.icon.presetImage} modifier={iconClass} />)
            : undefined;

        return (
            <a className="rj-hamburger-tabs-01-link" href={this.props.href} onClick={this.props.handler}>
                {navIcon}
                <span className="rj-hamburger-tabs-01-link-title">{this.props.title}</span>
                {this.props.count && (<span className="rj-hamburger-tabs-01-live-count">{this.props.count}</span>)}
            </a>
        )
    }
}